import { render, staticRenderFns } from "./StepCode.vue?vue&type=template&id=bea1081a&"
import script from "./StepCode.vue?vue&type=script&lang=js&"
export * from "./StepCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports